import yup from '#schema/locale';

export const affiliateDataSchema = yup.object({
  status: yup.string().required(),
  profile: yup.object({
    imageUrl: yup.string().required(),
    name: yup.string().required(),
  }),
});
